import Checkbox from '@components/v2/form/Checkbox/Checkbox';
import TextField from '@components/v2/form/TextField/TextField';
import Button from '@components/v2/ui/Button/Button';
import Typography from '@components/v2/ui/Typography/Typography';
import { Box } from '@mui/material';
import { Controller } from 'react-hook-form';
import LangEnum from '../../../lang/LangEnum';
import { useTranslation } from '../../translation/TranslationContext';
import useNpsContactMeForm from '../hooks/useNpsContactMeForm';

const NpsContactMeForm = () => {
  const { translate } = useTranslation();
  const { control, register, isSubmitting, handleValidSubmit, handleAnswerJump } =
    useNpsContactMeForm();

  return (
    <Box sx={{ width: 360, maxWidth: '100%' }}>
      <form onSubmit={handleValidSubmit}>
        <Box sx={{ pb: 1.5 }}>
          <Typography variant="subtitle1" sx={{ fontWeight: 'medium' }}>
            {translate(LangEnum.NPS_ANSWER_MOTIVATION_TEXT)}
          </Typography>
        </Box>

        <Box sx={{ pb: 1.5 }}>
          <TextField
            multiline
            maxRows={3}
            label={translate(LangEnum.GLOBAL_COMMENT)}
            {...register('observation')}
          />
        </Box>

        <Box sx={{ pb: 2 }}>
          <Controller
            name="contactMe"
            control={control}
            render={({ field }) => (
              <Checkbox
                label={translate(LangEnum.NPS_CONTACT_ME_TEXT)}
                checked={field.value}
                onChange={(_, checked) => field.onChange(checked)}
              />
            )}
          />
        </Box>

        <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 1.5 }}>
          <Button
            variant="contained"
            color="secondary"
            size="medium"
            disabled={isSubmitting}
            onClick={handleAnswerJump}
          >
            {translate(LangEnum.GLOBAL_SKIP_BUTTON_LABEL)}
          </Button>
          <Button
            variant="contained"
            color="primary"
            size="medium"
            type="submit"
            loading={isSubmitting}
          >
            {translate(LangEnum.GLOBAL_SEND_COMMENT_BUTTON_LABEL)}
          </Button>
        </Box>
      </form>
    </Box>
  );
};

export default NpsContactMeForm;
